"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var react_components_1 = require("@apollo/react-components");
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var React = __importStar(require("react"));
var App_1 = require("../../App");
// tslint:disable-next-line:max-line-length
var RestMutations_1 = require("../../Common/RestMutations");
var VerifyAccountContext_1 = __importDefault(require("../VerifyAccountContext"));
exports.graphqlMutation = graphql_tag_1["default"](templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation generatePasscodeBFF(\n    $channel: String!\n    $action: String!\n    $overrideId: String!\n    $overrideType: String!\n  ) {\n    generatePasscode(\n      channel: $channel\n      action: $action\n      overrideId: $overrideId\n      overrideType: $overrideType\n    ) {\n      channel\n      contactAddress\n      userId\n      tokenExpiresAt\n      attemptsRemaining\n    }\n  }\n"], ["\n  mutation generatePasscodeBFF(\n    $channel: String!\n    $action: String!\n    $overrideId: String!\n    $overrideType: String!\n  ) {\n    generatePasscode(\n      channel: $channel\n      action: $action\n      overrideId: $overrideId\n      overrideType: $overrideType\n    ) {\n      channel\n      contactAddress\n      userId\n      tokenExpiresAt\n      attemptsRemaining\n    }\n  }\n"])));
var GeneratePasscodeMutation = function (_a) {
    var children = _a.children;
    var _b = React.useContext(App_1.RiskContext), client = _b.client, state = _b.state;
    var _c = React.useContext(VerifyAccountContext_1["default"]), overrideId = _c.overrideId, overrideType = _c.overrideType;
    var action = (state && state.workflow) || 'default';
    return (React.createElement(react_components_1.Mutation, { mutation: client ? exports.graphqlMutation : RestMutations_1.generatePasscodeRest }, function (mutate, res) {
        return children(function (channel) {
            return mutate({
                variables: { channel: channel, action: action, overrideId: overrideId, overrideType: overrideType }
            });
        }, res);
    }));
};
exports["default"] = GeneratePasscodeMutation;
var templateObject_1;
